var app = angular.module("leonardo");

var SelectStartDate = function($scope, AuthDataService,
  $q, $rootScope,$state,WorkFlowService,ngDialog,
  FilterService,PropertyService, NotificationService,FormErrorsService, $filter) {

  $scope.permission = $scope.ngDialogData ? $scope.ngDialogData.permission : null;

  $scope.authDataService = AuthDataService;

  $scope.account = $scope.ngDialogData && $scope.ngDialogData.account  ? $scope.ngDialogData.account : null;

  $scope.workflow = $scope.ngDialogData.workflow;
  $scope.workflow_id = $scope.ngDialogData.workflow.id;
  $scope.parent_property = $scope.ngDialogData.property;
  $scope.filter_conditions = $scope.ngDialogData.filter_conditions;

  $scope.date_turn = moment().format('YYYY-MM-DD');
  $scope.property = $scope.ngDialogData.property;
  $state.time_zone = null;
  $scope.workFlowService = WorkFlowService;
  $scope.launching = false;

  $scope.submit = function () {
    $scope.Form.$setSubmitted();
    if ($scope.Form.$invalid) {
      FormErrorsService.goToError();
      return;
    }
    if ($scope.launching) {
      return;
    }
    $scope.launching = true;

    var unitWorkFlowPayLoad = {
      name: $scope.workflow.name,
      workflow_id:$scope.workflow_id,
      active_templates: $scope.workflow.templates.map(x=>x.id),
      property: $scope.property,
      account_id:$scope.account,
      date_of_turn: $scope.date_turn,
      filter_conditions:$scope.filter_conditions
    }

    var workFlowPayLaod = {
      name: $scope.workflow.name,
      workflow_id:$scope.workflow_id,
      active_templates: $scope.workflow.templates.map(x=>x.id),
      property: $scope.property,
      account_id:$scope.account,
      date_of_turn: $scope.date_turn,
    }
    $scope.workFlowService
      .massLaunchWorkflows($scope.workflow.by_unit ? unitWorkFlowPayLoad : workFlowPayLaod)
      .then(
        function handleResult(finalResult) {
            const message = $scope.workflow.by_unit
              ? 'Your unit workflow(s) have been launched and will be available once the launch process has been completed.'
              : 'Your workflow(s) have been launched and will be available once the launch process has been completed.';
            NotificationService.notify('success', message);
            $rootScope.$broadcast('workflow-tasks:updated');
            $scope.confirm();
          $scope.refresh();
        },
        function () {
          $scope.launching = false;
          $scope.confirm();
        }
      );
  };

};



app.controller('SelectStartDate', ['$scope', 'AuthDataService', '$q', '$rootScope', '$state',
  'WorkFlowService', 'ngDialog', 'FilterService', 'PropertyService','NotificationService','FormErrorsService','$filter', SelectStartDate]);
